import { render, staticRenderFns } from "./ProductContainersDialog.vue?vue&type=template&id=64a33e58&scoped=true"
import script from "./ProductContainersDialog.vue?vue&type=script&lang=js"
export * from "./ProductContainersDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductContainersDialog.vue?vue&type=style&index=0&id=64a33e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a33e58",
  null
  
)

export default component.exports